import {
  iconButtonVariants,
  type IconButtonVariant
} from '@/components/ui/button-variants';
import { cn } from '@/lib/cn';
import { type ButtonHTMLAttributes } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  'aria-label': string;
  variant?: IconButtonVariant;
  size?: 'sm' | 'md';
};

export function IconButton({
  className,
  variant = 'ghost',
  size = 'md',
  type = 'button',
  ...props
}: Props) {
  return (
    <button
      type={type}
      className={cn(iconButtonVariants({ variant, size }), className)}
      {...props}
    />
  );
}
